// TODO: Use the introduced ua-parser-js to do this.

export const isMobile = () => {
  if (typeof window === 'undefined') return false;

  const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  return isMobileDevice;
};

const webViewRules = [
  // if it says it's a webview, let's go with that
  'WebView',
  // iOS webview will be the same as safari but missing "Safari"
  '(iPhone|iPod|iPad)(?!.*Safari)',
  // Android Lollipop and Above: webview will be the same as native but it will contain "wv"
  // Android KitKat to Lollipop webview will put Version/X.X Chrome/{version}.0.0.0
  'Android.*(;\\s+wv|Version/\\d.\\d\\s+Chrome/\\d+(\\.0){3})',
  // old chrome android webview agent
  'Linux; U; Android',
];

const webviewRegExp = new RegExp('(' + webViewRules.join('|') + ')', 'ig');

export const inWebView = () => {
  try {
    return webviewRegExp.test(window.navigator.userAgent);
  } catch {
    return false;
  }
};

export const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
